"use client";

import { createContext, useContext } from "react";

/** Set by the player only, so the editor canvas never navigates. */
export const PlayerGoToPageContext = createContext<
    ((pageId: string) => void) | null
>(null);

export const usePlayerGoToPage = () => useContext(PlayerGoToPageContext);
